export const useMatterId = createGlobalState(() => {
  const matterId = useLocalStorage<string | null>('matterReferenceId', null)

  const isMatterId = computed(() => !!matterId.value)

  return {
    matterId,
    isMatterId,
  }
})
